import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import HowItWorks from './pages/HowItWorks';
import ForEducators from './pages/ForEducators';
import ForParents from './pages/ForParents';
import ForStudents from './pages/ForStudents';
import ForSchools from './pages/ForSchools';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import GivingBack from './pages/GivingBack';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Presentation from './pages/Presentation';
import PresentationInvestor from './pages/PresentationInvestor';
import PresentationGTM from './pages/PresentationGTM';
import PresentationTeacher from './pages/PresentationTeacher';
import PresentationFF from './pages/PresentationFF';
import PresentationInitialRaise from './pages/PresentationInitialRaise';
import AiTech from './pages/AiTech';
import NotFound from './pages/NotFound';
import { QuoteGeneratorPage, PrintableQuote } from './tools/quote-generator';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Presentation routes - full screen, no layout */}
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/presentation-investor" element={<PresentationInvestor />} />
        <Route path="/presentation-gtm" element={<PresentationGTM />} />
        <Route path="/presentation-teacher" element={<PresentationTeacher />} />
        <Route path="/presentation-ff" element={<PresentationFF />} />
        <Route path="/presentation-initial-raise" element={<PresentationInitialRaise />} />

        {/* Tools routes - isolated, no layout */}
        <Route path="/tools/quote-generator" element={<QuoteGeneratorPage />} />
        <Route path="/tools/quote-generator/print" element={<PrintableQuote />} />

        {/* All other routes with standard layout */}
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/features" element={<Features />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/for-educators" element={<ForEducators />} />
                <Route path="/for-parents" element={<ForParents />} />
                <Route path="/for-students" element={<ForStudents />} />
                <Route path="/for-schools" element={<ForSchools />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/giving-back" element={<GivingBack />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/ai-tech" element={<AiTech />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;